import React from "react";
import SurveyModal from "./SurveyModal";
import DevSettingsDrawer from "./DevSettingsDrawer";
import { shouldShowDevSettings } from "../../utils/embedGating";

/**
 * TRAC-497: the chat overlays (post-conversation Survey and the dev-only
 * Settings drawer) extracted from ChatInterface. Pure
 * presentational grouping — the parent still owns all open/close state and the
 * dev handlers; this component only renders the modals and preserves the
 * shouldShowDevSettings gate on the drawer (TRAC-81/291, TRACI-933).
 */

interface ChatModalsProps {
  // Post-conversation survey
  isSurveyOpen: boolean;
  onCloseSurvey: () => void;
  sessionId: string | null;
  getToken: () => Promise<string | undefined>;

  // Dev settings drawer
  showDevSettings: boolean;
  onCloseDevSettings: () => void;
  chunkTimeout: number | null;
  onChunkTimeoutChange: (seconds: number | null) => void;
  onSimulateSessionExpiry: () => void;
  onSeverHandoffBridge?: (dropResume: boolean) => Promise<void>;
  handoffActive?: boolean;
  onExperimentChange: () => void;
}

const ChatModals: React.FC<ChatModalsProps> = ({
  isSurveyOpen,
  onCloseSurvey,
  sessionId,
  getToken,
  showDevSettings,
  onCloseDevSettings,
  chunkTimeout,
  onChunkTimeoutChange,
  onSimulateSessionExpiry,
  onSeverHandoffBridge,
  handoffActive,
  onExperimentChange,
}) => {
  return (
    <>
      {/* Survey Modal */}
      <SurveyModal
        isOpen={isSurveyOpen}
        onClose={onCloseSurvey}
        userEmail={undefined}
        sessionId={sessionId}
        getToken={getToken}
      />

      {/* Dev Settings Drawer (TRAC-81, TRAC-291): never mounted on a prod build (TRACI-933). */}
      {shouldShowDevSettings(import.meta.env.VITE_ENV || "dev") && (
        <DevSettingsDrawer
          isOpen={showDevSettings}
          onClose={onCloseDevSettings}
          chunkTimeout={chunkTimeout}
          onChunkTimeoutChange={onChunkTimeoutChange}
          onSimulateSessionExpiry={onSimulateSessionExpiry}
          onSeverHandoffBridge={onSeverHandoffBridge}
          handoffActive={handoffActive}
          onExperimentChange={onExperimentChange}
          getToken={getToken}
        />
      )}
    </>
  );
};

export default ChatModals;
